import React from 'react';

const FileChangeFeedSkeleton = ({ filterChipCount = 2 }) => (
  <div className="space-y-6">
    {/* <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="h-24 animate-pulse rounded-xl border border-border/25 bg-transparent"
        />
      ))}
    </div> */}

    <div className="space-y-4 py-2">
      <div className="h-11 animate-pulse rounded-xl border border-border/25 bg-transparent" />
    </div>

    <div className="space-y-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-xl border border-border/25 bg-transparent"
        >
          <div className="h-24 animate-pulse border-b border-border/20 bg-transparent" />
          <div className="space-y-3 p-4">
            {Array.from({ length: 2 }).map((__, rowIndex) => (
              <div
                key={rowIndex}
                className="h-16 animate-pulse border-b border-border/15 bg-transparent"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FileChangeFeedSkeleton;
